export default __webpack_public_path__ + "static/OpenSans-Regular-967e123ad65de8c5d5c464071bdb4979.woff2";